import React from "react";
import CssClasses from "./CalendarDayButton.css";

const CalendarDayButton = props => {
  let classes = [CssClasses.button];

  if (props.isActive) {
    classes.push(CssClasses.active);
  }

  let markup;

  if (props.isBigText) {
    markup = <span className={CssClasses.bigText}>{props.bigText}</span>;
  } else {
    markup = (
      <div>
        <span className={CssClasses.dayNumber}>{props.dayNumber}</span>
        <span className={CssClasses.dayLabel}>{props.dayLabel}</span>
      </div>
    );
  }

  return (
    <div
      onClick={() => {
        props.onButtonClicked(props.id, props.date);
      }}
      className={classes.join(" ")}
    >
      {markup}
    </div>
  );
};

export default CalendarDayButton;



// WEBPACK FOOTER //
// ./src/Components/UI/CalendarDayButton/CalendarDayButton.js